// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__t648T"};